import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 15 11\" id=\"check\">\r\n<g>\r\n\t<path d=\"M0.2,6.1C0.1,5.9,0,5.8,0,5.7s0.1-0.3,0.2-0.4L1,4.5c0.2-0.2,0.6-0.2,0.8,0l0.1,0.1L5,7.8c0.1,0.1,0.3,0.1,0.4,0l7.7-7.6\r\n\t\th0.1l0,0l0,0c0.2-0.2,0.6-0.2,0.8,0l0.8,0.8c0.2,0.2,0.2,0.6,0,0.8l0,0l0,0l-9.2,9.1C5.5,10.9,5.4,11,5.2,11\r\n\t\tc-0.2,0-0.3-0.1-0.4-0.2L0.3,6.2L0.2,6.1z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol